export const gooutRouting = [
  {
    path: "/attendance/goout/list",
    name: "attendance-goout-list",
    meta: { title: "外出申请" },
    component: () =>
      import(
        /* webpackChunkName: "attendance-goout" */ "@/views/attendance-management/goout-application/list/index.vue"
      ),
  },
  {
    hidden: true,
    path: "/attendance/goout/create",
    name: "attendance-goout-create",
    meta: { title: "新建外出申请" },
    component: () =>
      import(
        /* webpackChunkName: "attendance-goout" */ "@/views/attendance-management/goout-application/form-create/index.vue"
      ),
  },
  {
    hidden: true,
    path: "/attendance/goout/edit/:id",
    name: "attendance-goout-edit",
    meta: { title: "编辑外出申请" },
    component: () =>
      import(
        /* webpackChunkName: "attendance-goout" */ "@/views/attendance-management/goout-application/form-create/index.vue"
      ),
  },
  {
    hidden: true,
    path: "/attendance/goout/detail/:id",
    name: "attendance-goout-detail",
    meta: { title: "外出申请详情" },
    component: () =>
      import(
        /* webpackChunkName: "attendance-goout" */ "@/views/attendance-management/goout-application/form-detail/index.vue"
      ),
  },
  {
    hidden: true,
    path: "/attendance/goout/flowPrint/:id",
    name: "attendance-goout-flow-print",
    meta: { title: "打印详情" },
    component: () =>
        import(
            /* webpackChunkName: "attendance-goout" */ "@/views/attendance-management/goout-application/flow-print/index.vue"
            ),
  },
];
